import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

const Freeconsultation = () => {
    return (
        <section className="hero-section">
            <div className="hero-overlay"></div>

            <Container>
                <Row className="align-items-center">

                    {/* LEFT CONTENT */}
                    <Col lg={6} className="text-white hero-left">
                        <h1 className="hero-title">
                            We breathe marketing and <br /> exhale digital.
                        </h1>

                        <p className="hero-text">
                            We breathe marketing and exhale digital ad ipiscing elit. sed do
                            eiusmod tempor labore et dolore magna aliqua business. Duis aute
                            irure dolor in reprehenderit in voluptate velit esse cillum.
                        </p>

                        <div className="hero-info d-flex align-items-center gap-4 mt-4 flex-wrap">
                            {/* <div className="info-box"> */}
                                {/* <span className="icon-circle">⚙️</span>
                                <span>Consulting & Strategy</span> */}
                                <Button className="btn-grad border-0 btn btn-primary">
                                   Consulting & Strategy
                                </Button>
                            {/* </div> */}
 
                            <div className="stats">
                                <h3>863+</h3>   
                                <span>Our Worlds Clients</span>
                            </div>
                        </div>
                    </Col>

                    {/* RIGHT FORM */}
                    <Col lg={5} className="ms-auto">
                        <div className="consultation-card">
                            <span className="form-tag ">GET MORE UPDATES</span>
                            <h3 className="mb-4 mt-2">Free Consultation</h3>

                            <Form>
                                <Form.Control placeholder="Name" className="mb-3" />
                                <Form.Control placeholder="Email Address" className="mb-3" />
                                <Form.Control placeholder="Phone Number" className="mb-3" />
                                <Form.Select className="mb-4">
                                    <option>Subject</option>
                                    <option>Digital Marketing</option>
                                    <option>Web Development</option>
                                </Form.Select>

                                <Button className="w-100 btn-grad border-0 btn btn-primary">
                                    CONSULTATION
                                </Button>
                            </Form>
                        </div>
                    </Col>

                </Row>
            </Container>
        </section>
    );
};

export default Freeconsultation;
